import React, { useState } from 'react';
import { ShieldAlert } from 'lucide-react';

interface Props {
  onAgree: () => void;
}

export default function AgeGateAndToS({ onAgree }: Props) {
  const [is18, setIs18] = useState(false);
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4">
      <div className="max-w-lg w-full terminal-screen rounded-sm p-6 shadow-[0_0_30px_rgba(217,119,6,0.15)] font-mono">
        <div className="flex items-center gap-3 mb-4 text-amber-500 relative z-10">
          <ShieldAlert size={32} />
          <h2 className="text-xl font-bold text-amber-500 font-orbitron tracking-wider">Safety & Terms of Service</h2>
        </div>
        
        <div className="text-amber-600 text-sm space-y-4 mb-6 max-h-60 overflow-y-auto pr-2 relative z-10">
          <p>Welcome to the Tucson Cyber-West chat terminal. To ensure a safe environment, please acknowledge the following:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>You must be 18 years of age or older to participate.</li>
            <li>Harassment, insults, hate speech, or promotion of illegal acts will result in a <strong>lifetime ban</strong>.</li>
            <li>Be respectful and use common sense.</li>
            <li><strong>Liability Waiver:</strong> By participating, you agree that Tucson Cyber-West and its operators are not liable for any content posted by users or any damages arising from the use of this chat service. You use this service at your own risk.</li>
          </ul>
        </div>

        <div className="space-y-3 mb-6 relative z-10">
          <label className="flex items-center gap-2 text-amber-500 cursor-pointer">
            <input type="checkbox" checked={is18} onChange={(e) => setIs18(e.target.checked)} className="accent-amber-600" />
            I am 18 years of age or older.
          </label>
          <label className="flex items-center gap-2 text-amber-500 cursor-pointer">
            <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} className="accent-amber-600" />
            I agree to the Terms of Service and Rules.
          </label>
        </div>

        <button 
          onClick={onAgree}
          disabled={!is18 || !agreed}
          className="w-full py-3 bg-amber-600 text-black rounded-sm font-bold disabled:bg-stone-900 disabled:text-stone-600 transition-colors uppercase tracking-widest relative z-10"
        >
          Enter Terminal
        </button>
      </div>
    </div>
  );
}
